import { api } from './index';

import type {
  BookMemberBiweeklyRequest,
  BookMemberBiweeklyResponse,
  GetMemberBiweeklyBookingParams,
  GetMemberBiweeklyRescheduleOptionsParams,
  MemberBiweeklyBookingContext,
  MemberBiweeklyRescheduleOptions,
  RescheduleMemberBiweeklyRequest,
  RescheduleMemberBiweeklyResponse,
} from '@/types';

export const memberBiweeklyBookingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bookMemberBiweekly: builder.mutation<
      BookMemberBiweeklyResponse,
      BookMemberBiweeklyRequest
    >({
      invalidatesTags: ['Session'],
      query: ({
        coachId,
        idempotencyKey,
        memberId,
        startTime,
        viewerTimezone,
      }) => ({
        data: {
          coach_id: coachId,
          idempotency_key: idempotencyKey,
          ...(memberId ? { member_id: memberId } : {}),
          start_time: startTime,
          viewer_timezone: viewerTimezone,
        },
        method: 'POST',
        url: '/member_biweekly_bookings',
      }),
    }),
    getMemberBiweeklyBooking: builder.query<
      MemberBiweeklyBookingContext,
      GetMemberBiweeklyBookingParams
    >({
      providesTags: ['Session'],
      query: ({ coachId, memberId, viewerTimezone, visibleWeeks }) => ({
        method: 'GET',
        params: {
          viewer_timezone: viewerTimezone,
          visible_weeks: visibleWeeks,
          ...(memberId ? { member_id: memberId } : {}),
        },
        url: `/member_biweekly_bookings/${encodeURIComponent(coachId)}`,
      }),
    }),
    getMemberBiweeklyRescheduleOptions: builder.query<
      MemberBiweeklyRescheduleOptions,
      GetMemberBiweeklyRescheduleOptionsParams
    >({
      providesTags: ['Session'],
      query: ({ coachId, viewerTimezone }) => ({
        method: 'GET',
        params: { viewer_timezone: viewerTimezone },
        url: `/member_biweekly_bookings/${encodeURIComponent(coachId)}/reschedule_options`,
      }),
    }),
    rescheduleMemberBiweekly: builder.mutation<
      RescheduleMemberBiweeklyResponse,
      RescheduleMemberBiweeklyRequest
    >({
      invalidatesTags: ['Session'],
      query: ({
        coachId,
        mutationId,
        seriesId,
        startTime,
        viewerTimezone,
      }) => ({
        data: {
          coach_id: coachId,
          mutation_id: mutationId,
          series_id: seriesId,
          start_time: startTime,
          viewer_timezone: viewerTimezone,
        },
        method: 'POST',
        url: '/member_biweekly_bookings/reschedule',
      }),
    }),
  }),
});

export const {
  useBookMemberBiweeklyMutation,
  useGetMemberBiweeklyBookingQuery,
  useGetMemberBiweeklyRescheduleOptionsQuery,
  useRescheduleMemberBiweeklyMutation,
} = memberBiweeklyBookingApi;
